import { useMemo } from "react";

// ── Helpers ────────────────────────────────────────────────────────────────────

const getFilters = (key, data) =>
  [...new Set((data || []).map((item) => item[key]).filter(Boolean))]
    .sort((a, b) => {
      const aNum = /^\d/.test(a);
      const bNum = /^\d/.test(b);
      if (aNum && !bNum) return -1;
      if (!aNum && bNum) return 1;
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    })
    .map((value) => ({ text: value, value }));

const buildFilterableColumn = (title, dataIndex, data) => ({
  title,
  dataIndex,
  filters: getFilters(dataIndex, data),
  onFilter: (value, record) => record[dataIndex] === value,
  render: (val) => val || "--",
});

// ── Column definitions ─────────────────────────────────────────────────────────
// Filterable columns: title + dataIndex only — the rest is generated by buildFilterableColumn.

const FILTERABLE_COLUMN_DEFS = [
  { title: "Employee Name", dataIndex: "employee_name" },
  { title: "Requisition No.", dataIndex: "requisition_number" },
  { title: "Job Code",      dataIndex: "job_code"      },
  { title: "Role Name",     dataIndex: "role_name"     },
  { title: "Business",      dataIndex: "business_unit" },
  { title: "Function",      dataIndex: "function"      },
  { title: "Sub-Function",  dataIndex: "sub_function"  },
  { title: "Job Level",     dataIndex: "job_level"     },
  { title: "Location",      dataIndex: "location"      },
  { title: "Manager Name",  dataIndex: "manager_name"  },
];

// ── Hook ───────────────────────────────────────────────────────────────────────
// Rebuilds only when filteredData changes (filter options depend on it).

const useSkillsBridgerColumns = (filteredData) =>
  useMemo(
    () =>
      FILTERABLE_COLUMN_DEFS.map(({ title, dataIndex }) =>
        buildFilterableColumn(title, dataIndex, filteredData)
      ),
    [filteredData]
  );

export default useSkillsBridgerColumns;
